
const timestampToTime = (timestamp, b) => {
  let obj = {}
  const date = new Date(timestamp * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + b
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + b
  const D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ' '
  const h = ' ' + (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  obj['date'] = Y + M + D
  obj['time'] = h + m + s
  return obj
}
export { timestampToTime }
